import React from 'react';

import styles from './BackButton.module.scss';

type BackLinkProps = {
  onClick: () => void | Promise<void>;
  text: string;
};

export const BackButton = ({ onClick, text }: BackLinkProps) => {
  return (
    <button data-testid="back-button" className={styles.linkButton} onClick={onClick}>
      <img
        className={styles.buttonIcon}
        src="https://www.haven.com/assets/icons/chevron-b-left-blue.svg"
        alt="go back"
      />
      {text}
    </button>
  );
};
